import { render, staticRenderFns } from "./ContractDashboardB.vue?vue&type=template&id=735c56ca"
import script from "./ContractDashboardB.vue?vue&type=script&lang=js"
export * from "./ContractDashboardB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports